import { SearchColumnDef } from '@/components/custom/erp';

export const getDocumentTypeColumns: SearchColumnDef[] = [
  {
    field: 'documentCode',
    headerName: 'Mã chứng từ',
    width: 150
  },
  {
    field: 'documentName',
    headerName: 'Tên chứng từ',
    width: 300
  }
];

export const getBookTableColumns: SearchColumnDef[] = [
  {
    field: 'bookCode',
    headerName: 'Mã quyển',
    width: 150
  },
  {
    field: 'bookName',
    headerName: 'Tên quyển',
    width: 250
  },
  {
    field: 'templateNumber',
    headerName: 'Mẫu số',
    width: 150
  },
  {
    field: 'symbol',
    headerName: 'Ký hiệu',
    width: 150
  }
];

export const getPartnerColumns: SearchColumnDef[] = [
  {
    field: 'partnerCode',
    headerName: 'Mã đối tượng',
    width: 150
  },
  {
    field: 'partnerName',
    headerName: 'Tên đối tượng',
    width: 250
  },
  {
    field: 'debitAmount',
    headerName: 'Công nợ p/thu',
    width: 150
  },
  {
    field: 'creditAmount',
    headerName: 'Công nợ p/trả',
    width: 150
  },
  {
    field: 'taxCode',
    headerName: 'Mã số thuế',
    width: 150
  },
  {
    field: 'email',
    headerName: 'Email',
    width: 180
  },
  {
    field: 'phoneNumber',
    headerName: 'Số điện thoại',
    width: 180
  }
];

export const getCurrencyColumns: SearchColumnDef[] = [
  {
    field: 'currencyCode',
    headerName: 'Ngoại tệ',
    width: 150
  },
  {
    field: 'currencyName',
    headerName: 'Tên ngoại tệ',
    width: 180
  }
];

export const getAreaColumns: SearchColumnDef[] = [
  {
    field: 'areaCode',
    headerName: 'Mã khu vực',
    width: 150
  },
  {
    field: 'areaName',
    headerName: 'Tên khu vực',
    width: 250
  }
];

export const getEmployeeColumns: SearchColumnDef[] = [
  {
    field: 'employeeCode',
    headerName: 'Mã nhân viên',
    width: 150
  },
  {
    field: 'employeeName',
    headerName: 'Tên nhân viên',
    width: 250
  }
];

export const getAccountColumns: SearchColumnDef[] = [
  {
    field: 'accountCode',
    headerName: 'Mã tài khoản',
    width: 150
  },
  {
    field: 'accountName',
    headerName: 'Tên tài khoản',
    width: 250
  },
  {
    field: 'parentAccount',
    headerName: 'Tài khoản mẹ',
    width: 150
  },
  {
    field: 'isPrimary',
    headerName: 'TK sổ cái',
    width: 80,
    renderCell: params => (
      <input type='checkbox' className='cursor-pointer' checked={params.value} aria-label={`Select row ${params.id}`} />
    )
  },
  {
    field: 'isDetail',
    headerName: 'TK chi tiết',
    width: 80,
    renderCell: params => (
      <input type='checkbox' className='cursor-pointer' checked={params.value} aria-label={`Select row ${params.id}`} />
    )
  },
  {
    field: 'level',
    headerName: 'Bậc tk',
    width: 100
  }
];

export const getGroupColumns: SearchColumnDef[] = [
  {
    field: 'groupCode',
    headerName: 'Mã nhóm',
    width: 150
  },
  {
    field: 'groupName',
    headerName: 'Tên nhóm',
    width: 250
  }
];

export const getPaymentMethodColumns: SearchColumnDef[] = [
  {
    field: 'paymentCode',
    headerName: 'Mã thanh toán',
    width: 150
  },
  {
    field: 'paymentName',
    headerName: 'Tên thanh toán',
    width: 250
  },
  {
    field: 'dueDate',
    headerName: 'Hạn thanh toán',
    width: 150
  }
];

export const getMethodColumns: SearchColumnDef[] = [
  {
    field: 'methodCode',
    headerName: 'Mã phương thức',
    width: 150
  },
  {
    field: 'methodName',
    headerName: 'Tên phương thức',
    width: 250
  }
];
